import { GatewayControleQuinquennal } from "@conformite/gateway";
import { InfoCard, Button } from "@endya-conformite/ui-kit";
import { UnreadDocumentsNotice } from "@src/components/controle-quinquennal/UnreadDocumentsNotice/UnreadDocumentsNotice";
import styles from "./SubAxisVerificationBanner.module.scss";

type SubAxisVerificationBannerProps = {
  verification?: GatewayControleQuinquennal.ControleQuinquennalSubAxisVerification;
  onRelaunch?: () => void;
  isRelaunching?: boolean;
};

export function SubAxisVerificationBanner({
  verification,
  onRelaunch,
  isRelaunching,
}: SubAxisVerificationBannerProps) {
  if (!verification) return null;

  if (
    verification.status ===
    GatewayControleQuinquennal.VerificationStatus.PENDING
  ) {
    return (
      <InfoCard type="info" className={styles.banner}>
        Analyse IA en cours…
      </InfoCard>
    );
  }

  if (
    verification.status === GatewayControleQuinquennal.VerificationStatus.FAILED
  ) {
    return (
      <InfoCard type="error" className={styles.banner}>
        <div className={styles.bannerBody}>
          <p className={styles.bannerTitle}>Analyse IA en échec</p>
          {verification.errorMessage && <p>{verification.errorMessage}</p>}
          {onRelaunch && (
            <Button
              variant="outline-accent"
              className={styles.relaunchButton}
              onClick={onRelaunch}
              disabled={isRelaunching}
            >
              Relancer l&apos;analyse de ce contrôle
            </Button>
          )}
        </div>
      </InfoCard>
    );
  }

  return (
    <UnreadDocumentsNotice
      aiResult={verification.resultPayload}
      className={styles.banner}
    />
  );
}
